import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { UIView } from '@uirouter/react';
import { Button } from 'antd';
import { observer } from 'mobx-react-lite';
import { FormattedMessage } from 'react-intl';

import { Table } from '@/components/table';
import { PERMISSION_CREATE, PERMISSION_OBJ_COUNTERPARTY_CONTRACT } from '@/constants/permissions';
import { withPermissions } from '@/hocs/permission';
import { counterpartyContractStore } from '@/stores';
import { useMassUpdateCashedStores } from '@/utils/store';

import { columns } from './setup';

const entity = 'counterparty-contracts';
const store = counterpartyContractStore;

const CreateButton = withPermissions([[PERMISSION_OBJ_COUNTERPARTY_CONTRACT, PERMISSION_CREATE]])(
  ({ onClick }: any) => {
    return (
      <Button onClick={onClick} type="primary" icon={<FontAwesomeIcon icon={faPlus} />}>
        &nbsp;&nbsp;
        <FormattedMessage id="counterparty-contracts.add-new" />
      </Button>
    );
  },
);

export const Contracts = observer(({ transition }: any) => {
  const items = store.items;

  useMassUpdateCashedStores([store]);

  const onAdd = () => {
    transition.router.stateService.go(`base-layout.${entity}.create`);
  };

  return (
    <>
      <CreateButton onClick={onAdd} />
      <Table rowKey="id" bordered={true} columns={columns} dataSource={[...items]} store={store} scroll={{ x: 1500 }} />
      <UIView />
    </>
  );
});
